module.exports = __webpack_public_path__ + "static/media/register_background.bffdad7b.png";